import { ComponentProps, FC, PropsWithChildren } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { twMerge } from 'tailwind-merge';

type TooltipProps = {
  id?: string;
  tooltipContent: string;
};

type TooltipType = TooltipProps & Omit<ComponentProps<typeof ReactTooltip>, 'id'>;


const Tooltip: FC<PropsWithChildren<TooltipType>> = ({
  id,
  tooltipContent,
  children,
  className,
  ...rest
}) => {
    const tooltipId = id || uuidV4();
  
    return (
      <>
        <span
            data-tooltip-id={tooltipId}
            data-tooltip-content={tooltipContent}
            className="inline-block"
        >
            {children}
        </span>
        <ReactTooltip disableStyleInjection classNameArrow='h-8 w-8 rotate-45 rounded z-[-1]' className={twMerge('max-w-xs bg-brand-600 text-white-100 rounded-2xl p-3', className)} id={tooltipId} {...rest} />
      </>
    );
  };


export default Tooltip;

/**
 * For more usage examples, visit:
 * https://react-tooltip.com/docs/category/examples
 * 
 * USAGE EXAMPLE:
 *
 * <Tooltip tooltipContent="Click for more info">
 *   <button className="text-blue-600">Info</button>
 * </Tooltip>
 */